import React, { useState, useEffect } from 'react';
import './NotificationToast.css';

function NotificationToast({ message, nextAction, isOpen, onClose }) {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    if (isOpen) {
      // Scroll to current step if needed
      const activeStepElement = document.querySelector('.step-item.current');
      if (activeStepElement) {
        // Get current scroll position
        const currentScroll = window.scrollY;
        // Get element position
        const elementPosition = activeStepElement.getBoundingClientRect().top + currentScroll;
        // Adjust modal position to appear near the active step
        document.documentElement.style.setProperty('--modal-top', `${elementPosition}px`);
      } else {
        // Reset to default if no active step
        document.documentElement.style.setProperty('--modal-top', '0px');
      }
      
      setIsVisible(true);
      
      // Auto-dismiss after 8 seconds if not manually closed
      const timer = setTimeout(() => {
        handleClose();
      }, 8000);
      
      return () => clearTimeout(timer);
    }
  }, [isOpen]);
  
  const handleClose = () => {
    setIsVisible(false);
    
    // Delay the actual closing to allow animation to complete
    setTimeout(() => {
      if (onClose) {
        onClose();
      }
    }, 300); // Match this with the CSS transition time
  };
  
  // If not supposed to be open at all, don't render
  if (!isOpen && !isVisible) {
    return null;
  }
  
  return (
    <div className={`notification-overlay ${isVisible ? 'visible' : 'hidden'}`}>
      <div className="notification-toast">
        <div className="notification-header">
          <div className="notification-title">Step Complete!</div>
          <button className="close-button" onClick={handleClose}>&times;</button>
        </div>
        <div className="notification-body">
          <p className="notification-message">{message}</p>
          <div className="notification-next">
            <h4>Next Action:</h4>
            <p>{nextAction}</p>
          </div>
        </div>
        <div className="notification-footer">
          <button className="primary-button" onClick={handleClose}>Continue</button>
        </div>
      </div>
    </div>
  );
}

export default NotificationToast;